import { createContext, useContext } from "react";
import { MentionEditorHandle } from "../components/Shared/MentionInput";
import { TEMPLATE_GROUPS } from "../constants/aiAutomateSuggestions";

type TemplateGroupKey = keyof typeof TEMPLATE_GROUPS;

type Ctx = {
  editorRef: React.RefObject<MentionEditorHandle>;
  hasContent: boolean;
  setHasContent: (v: boolean) => void;
  activeTopic: TemplateGroupKey | null;
  setActiveTopic: (v: TemplateGroupKey | null) => void;
};

export const AIAutomateTabContext = createContext<Ctx | null>(null);

export const useAIAutomateTab = () => {
  const ctx = useContext(AIAutomateTabContext);
  if (!ctx) throw new Error("useAIAutomate must be used inside AIAutomate");
  return ctx;
};
